import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import BulkUpload from "../pages/Admin/BulkUpload/BulkUpload";
import CertificateList from "../pages/Admin/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/Admin/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/Admin/Certificate/ViewCertificate/ViewCertificate";
import Course from "../pages/Admin/Course/Course";
import Profile from "../pages/Admin/Profile/Profile";
import Staff from "../pages/Admin/Staff/Staff";

var AdminRoutes = [
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "staff",
    name: "Staff",
    element: <Staff/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "course",
    name: "Course",
    element: <Course/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
//   {
//     path: "profile",
//     name: "Profile",
//     element: <Profile/>,
//     layout: 'admin',
//     icon: DashboardIcon,
//     inactiveIcon: InactiveDashboardIcon
// },
];
export default AdminRoutes;
